module.exports = __webpack_public_path__ + "assets/img/1801.4f116d93.svg";